import {AbstractControl} from '@angular/forms';

export function minValueValidator(min: number) {
    return (c: AbstractControl): { [key: string]: any } => {
        const isValid = (c.value == null || c.value.length === 0) || c.value >= min;
        if (!isValid) {
            return {'minValue': {min}};
        } else {
            return null;
        }

    };
}

export function minFieldSizeValidator(min: () => number) {
    return (c: AbstractControl): { [key: string]: any } => {
        const isValid = c.value == null || c.value.length >= min();
        if (!isValid) {
            return { minlength: false };
        } else {
            return null;
        }

    };
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/validators/min-value.ts